// groups
export enum EPartGroups {
  'Others' = 1,
  'Body' = 2,
  'Rims and Tires' = 3,
  'Engine' = 4,
  'Suspension' = 5,
  'Electrical' = 6,
  'Transmission' = 7,
  'Fuel' = 8,
  'Steering' = 9,
  'Exhaust' = 10,
  'Cooling' = 11,
  'Heat, Ventillation and AC' = 12,
  'Maintenance' = 13,
}

export const PartGroups = Object.entries(EPartGroups).filter(
  (t) => typeof t[1] === 'number',
)

// origins
export enum EPartOrigins {
  'Any' = 1,
  'Original' = 2,
  'OEM' = 3,
}

export const PartOrigins = Object.entries(EPartOrigins).filter(
  (t) => typeof t[1] === 'number',
)

// conditions
export enum EPartConditions {
  'Any' = 1,
  'New' = 2,
  'Used' = 3,
}

export const PartConditions = Object.entries(EPartConditions).filter(
  (t) => typeof t[1] === 'number',
)
